<template>
  <qx-card :noTitle="true">
    <BalanceDialog ref="balanceDialog" @sub="getData" />
    <h2 class="title posire">
      账户余额共（元）：
      <span class="error totalAmount">{{originData.totalBalance / 100}}</span>
      <span class="primary cur recordBtn posiab" @click="toRecord">账户流水</span>
    </h2>
    <!-- 找油账户 -->
    <qx-detail-box
      v-for="item in accountList"
      :key="item.id"
      :data="item"
      :colNum="1"
    >
      <!-- 余额 -->
      <section class="clearPa" slot="balance" slot-scope="prop">
        <article class="left error">{{prop.data.balance / 100}}元</article>
        <article class="right">
          <span class="primary btn cur" @click="showBalanceDialog(prop.data)">余额登记</span>
        </article>
      </section>
      <!-- 余额 end -->
    </qx-detail-box>
    <!-- 找油账户 end -->
  </qx-card>
</template>

<script>
import {
  otherAccountList,
} from 'api/getPay';
import BalanceDialog from './balanceDialog';
export default {
  components: {
    BalanceDialog,
  },
  data () {
    return {
      originData: {
        accountBalanceList: [],
      },
      findData: {
        label: 'ETC账户',
        tableData: {
          title: [
            {
              prop: 'balance',
              label: '余额',
              slot: true,
            },
            {
              prop: 'registrationDate',
              label: '余额更新时间',
            },
          ],
          data: {

          },
          approveData: {},
        },
      },
    };
  },
  computed: {
    accountList () {
      return this.originData.accountBalanceList.map((item) => ({
        label: item.accountTypeName,
        tableData: {
          title: [
            {
              prop: 'balance',
              label: '余额',
              span: 1,
              slot: true,
            },
            {
              prop: 'registrationDate',
              label: '余额更新时间',
            },
          ],
          data: item,
          approveData: {},
        },
      }));
    },
  },
  methods: {
    showBalanceDialog (item) { // 余额等级
      this.$refs.balanceDialog.show(item);
    },
    async getData () {
      this.originData = await otherAccountList();
    },
    toRecord () {
      this.jump({
        label: '账户流水',
        url: '/manage/getPay/account/other/record',
      });
    },
  },
  created () {
    this.getData();
  },
};
</script>

<style scoped lang="scss">
.title{
  height: 32px;
  padding-top: 8px;
  padding-bottom: 28px;
  border-bottom: 1px solid #e0e0e0;
  .totalAmount{
    font-size: 32px;
  }
  .recordBtn{
    right: 24px;
    bottom: 28px;
  }
}
.btn{
  margin-left: 16px;
}
</style>
